import LoadingOverlay from '@/components/loading/LoadingOverlay';
import { useAuthContext } from '@/contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '@/config/const';

const AuthCheckingRoutes = () => {
  const { isAuthenticated, isLoading, isRefreshing } = useAuthContext();

  if (isLoading || isRefreshing) {
    return <LoadingOverlay />;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.dashboard} replace />;
  }

  return <Navigate to={ROUTES.login} replace />;
};

export default AuthCheckingRoutes;
